const newsletterForms = document.querySelectorAll('[data-newsletter-form]');
const backInStockForms = document.querySelectorAll('[data-notification-form]');

const handleKlaviyoSubscriptions = (forms, listID) => {
  forms?.forEach((form) => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();

      const klaviyoListID = listID;
      const formData = new FormData(form);
      const submittedEmail = formData.get('contact[email]');

      if (!klaviyoListID) return;

      // Define the URL and the data we are going to send
      const url = 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe';
      const data = new URLSearchParams();
      data.append('g', klaviyoListID);
      data.append('email', submittedEmail);

      // Set up our HTTP request
      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Cache-Control': 'no-cache',
        },
        body: data,
      })
        // Parse the JSON-formatted response
        .then((response) => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json(); // or response.text() if the response is not in JSON format
        })
        .then((data) => {
          console.log(data);
          form.submit();
        })
        .catch((error) => {
          console.error('There was a problem with the fetch operation:', error);
        });
    });
  });
};

handleKlaviyoSubscriptions(newsletterForms, 'Rs8Cmi');

//api key = WKAunk

const handleBackInStockSubscriptions = (forms) => {
  forms?.forEach((form) => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();

      const variant = form.dataset.variantId;
      const formData = new FormData(form);
      const submittedEmail = formData.get('contact[email]');

      const klaviyoFormData = new FormData();
      klaviyoFormData.set('email', submittedEmail);
      klaviyoFormData.set('platform', 'shopify');
      klaviyoFormData.set('a', 'Ud5bFa');
      klaviyoFormData.set('variant', variant);

      // Define the URL and the data we are going to send
      const url = 'https://a.klaviyo.com/onsite/components/back-in-stock/subscribe';

      const formDataEntries = new URLSearchParams();
      for (let [key, value] of klaviyoFormData.entries()) {
        formDataEntries.append(key, value);
      }

      // Set up HTTP request
      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formDataEntries,
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.json(); // or .text() or .blob() etc., depending on the response type you expect
        })
        .then((data) => {
          console.log(data); // Process the success response
          form.submit();
        })
        .catch((error) => {
          console.error('Fetch error:', error.message);
        });
    });
  });
};

handleBackInStockSubscriptions(backInStockForms, '');
